import LegalPage from "./legalPage";
import { useTranslation } from "../../../../i18n/useTranslation";

const DataSovereignty = () => {
  const { t } = useTranslation();
  return <LegalPage title={t("legalDataSovereignty.title")} sections={t("legalDataSovereignty.sections")} />;
};

export default DataSovereignty;
